export const SET_EMPLOYEES = "SET_EMPLOYEES";
export const SET_LOGGEDIN = "SET_LOGGEDIN";
export const SET_POPUP = "SET_POPUP";
export const SET_ACCESSTOKEN = "SET_ACCESSTOKEN";
export const SET_USER = "SET_USER";
export const SET_CLIENTID = "SET_CLIENTID";
export const SET_CLIENTDETAILS = "SET_CLIENTDETAILS";
export const SET_COMPLIMENTDATA = "SET_COMPLIMENTDATA";